<template><div><h1>VUX V2.7.5 released</h1>
<h2><a href="/en/components/clocker.html">Clocker</a></h2>
<ul><li>[fix] fix this.clocker maybe undefined on hook:beforeDestroy #2258</li>
</ul>
<h2><a href="/en/components/panel.html">Panel</a></h2>
<ul><li>[fix] remove duplicate top border</li>
<li>[feature] add slot:header slot:body #2270</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[fix] fix plain and disabled class error</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.5 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.5-133.vue?6a0bfbf3